export const config =  {
  MAPFRE_SALUD: {
    homePageName: 'salud',
    urlScheme: 'tarjetadesalud',
    scheme: 'https',
    deepLinkHost: 'www.mapfre.es/appsalud',
  },
  AFIN: {
    homePageName: 'inversion',
    urlScheme: 'inversion',
    scheme: 'https',
    deepLinkHost: 'www.mapfre.es/appafin',
  }
};

export const paths =  {
  autologin: '/autologin'
};
